export const bar = {}



// WEBPACK FOOTER //
// ./src/types/bar.js